import styles from "./css/Children.module.css";
import { ChildrenTable } from "../components/children/ChildrenTable";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Paths } from "../routes/paths"; 
// import { UserHeader } from "../components/UserHeader";

export const ChildrenPage = () => {
  const navigate = useNavigate();

const analystCode = useSelector((state: any) => state.auth.user?.code);
  console.log(analystCode);
  return (
    <>
    {/* <UserHeader /> */}
    <div 
      className={styles.pageContainer}
      style={{
      }}>
      <div className={styles.card}>
        <h1 className={styles.title}>ניהול ילדים</h1>

        <div className={styles.topBar}>
          <button
            className={styles.button}
            onClick={() => navigate(`/${Paths.addChild}`)}
          >
            הוספת ילד
          </button>
        </div>

        <ChildrenTable analystCode={analystCode} />
      </div>
    </div>
    </>
  );
};
